/* Kliko home page – ported 1:1 from the approved preview. */
window.CFG={"material": "toon", "extras": "none", "strap": "#2a2a30", "bungee": "#c6ef3a", "seat": {"main": 13620184, "dark": 12041411}, "shadow": 1909024, "dog": {"fur": 14855544, "cream": 15913638, "ear": "floppy", "earColor": 13867618, "fluffy": true, "snout": 0.9, "harness": 14034479}, "cam": {"pos": [3.4, 3.3, 7.4], "look": [0, 1.35, 0], "fov": 34}, "light": {"sky": 16777215, "ground": 15333060, "hemi": 0.82, "dir": 0.8}, "autoBrake": true, "tapAct": "pet", "yaw": -0.3, "band": ["קליק אחד", "יוצאים לדרך", "חגורה ברכב", "רצועה בטיול", "בולם בנג'י", "משלוח חינם"], "bandSep": "●", "fx": {"pet": "צ'ילי מרוצה", "brake": "אופס!", "jump1": "רוצה החוצה!", "jump2": "הרצועה עצרה!"}, "labels": {}};
(function(){
  var C=window.CFG;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NF2=new Intl.NumberFormat("he-IL",{minimumFractionDigits:2,maximumFractionDigits:2}),NF0=new Intl.NumberFormat("he-IL",{maximumFractionDigits:0});function F(v){var r=Math.round(v*100)/100;return (r%1?NF2:NF0).format(r);}var MODELS=window.KLIKO.models;var model=Object.keys(MODELS)[0];var colors=MODELS[model].colors;
  var setStrapColor=function(){};

  // ---------- page UI ----------
  var swWrap=document.getElementById('swatches'), swName=document.getElementById('swName');
  var stageImg=document.getElementById('stageImg'), stageTag=document.getElementById('stageTag'), stagePrice=document.getElementById('stagePrice'), chipsWrap=document.getElementById('chips'), cur=0, cur2=0;
  function build(){
    colors=MODELS[model].colors; swWrap.innerHTML=''; chipsWrap.innerHTML='';
    colors.forEach(function(c,i){
      var b=document.createElement('button'); b.type='button'; b.className='sw'; b.style.background=c[1]; b.setAttribute('aria-label',c[0]);
      b.addEventListener('click',function(){ pick(i); }); swWrap.appendChild(b);
      var ch=document.createElement('button'); ch.type='button'; ch.className='chip'; ch.innerHTML='<i style="background:'+c[1]+'"></i>'+c[0];
      ch.addEventListener('click',function(){ pick(i); }); chipsWrap.appendChild(ch);
    });
    document.getElementById('modelDesc').textContent=MODELS[model].desc;
    document.querySelectorAll('.model').forEach(function(x){ x.setAttribute('aria-pressed',x.dataset.m===model?'true':'false'); });
    renderOffers(); pick(Math.min(cur,colors.length-1));
  }
  function pick(i){
    cur=i; var c=colors[i]; swName.textContent=c[0]; setStrapColor(c[1]);
    swWrap.querySelectorAll('.sw').forEach(function(x,j){x.setAttribute('aria-pressed',j===i?'true':'false')});
    chipsWrap.querySelectorAll('.chip').forEach(function(x,j){x.setAttribute('aria-pressed',j===i?'true':'false')});
    renderBuyColors();
    stageImg.classList.add('out');
    setTimeout(function(){ if(c[2]){stageImg.src=c[2];stageImg.hidden=false;} stageImg.alt='רצועת קליקו '+MODELS[model].name+' בצבע '+c[0]; stageTag.textContent=MODELS[model].name+' · '+c[0]; stagePrice.textContent=F(MODELS[model].one)+' ₪'; stageImg.classList.remove('out'); },160);
  }
  var offersWrap=document.getElementById('offers'), buyBtn=document.getElementById('buyBtn'), sel='one';
  var addon=document.getElementById('addon'), withBowl=false, ADDON=(window.KLIKO.bowl?window.KLIKO.bowl.price:0), lastO=null;
  function setSel(o){ lastO=o; sel=o.key; offersWrap.querySelectorAll('.offer').forEach(function(x){x.setAttribute('aria-checked',x.dataset.key===sel?'true':'false')});
    var nm=o.name+(withBowl?' + קערה':''), pr=o.price+(withBowl?ADDON:0);
    buyBtn.textContent='להזמנת '+nm+' · '+F(pr)+' ₪'; renderBuyColors(); document.getElementById('stickyName').textContent=nm; document.getElementById('stickyPrice').textContent=F(pr)+' ₪'; }
  if(addon) addon.addEventListener('click',function(){ withBowl=!withBowl; addon.setAttribute('aria-pressed',withBowl?'true':'false'); if(lastO) setSel(lastO); });
  var buyColors=document.getElementById('buyColors'), buySum=document.getElementById('buySum');
  function renderBuyColors(){
    if(!colors||!buyColors) return; if(cur2>=colors.length) cur2=0;
    var rows=sel==='pair'?[['צבע רצועה 1',cur,function(i){pick(i);}],['צבע רצועה 2',cur2,function(i){cur2=i;renderBuyColors();}]]:[['צבע הרצועה',cur,function(i){pick(i);}]];
    buyColors.innerHTML='';
    rows.forEach(function(r){
      var row=document.createElement('div'); row.className='bc-row';
      row.innerHTML='<div class="bc-label">'+r[0]+': <b>'+colors[r[1]][0]+'</b></div>';
      var w=document.createElement('div'); w.className='chips'; w.setAttribute('role','group'); w.setAttribute('aria-label',r[0]);
      colors.forEach(function(c,i){ var ch=document.createElement('button'); ch.type='button'; ch.className='chip'; ch.setAttribute('aria-pressed',i===r[1]?'true':'false');
        ch.innerHTML='<i style="background:'+c[1]+'"></i>'+c[0]; if((sel==='pair'?c[6]:c[5])===false){ch.disabled=true;ch.title='אזל זמנית';} ch.addEventListener('click',function(){ r[2](i); }); w.appendChild(ch); });
      row.appendChild(w); buyColors.appendChild(row);
      var on=w.children[r[1]]; if(on) w.scrollLeft=0;
    });
    var cs=sel==='pair'?colors[cur][0]+' + '+colors[cur2][0]:colors[cur][0];
    buySum.textContent='נבחר: '+(lastO?lastO.name:'')+' · '+cs+(withBowl?' · עם קערה':'');
  }
  function renderOffers(){
    var m=MODELS[model], list=[{key:'one',name:'רצועה '+m.name,price:m.one,p:'לכלב אחד ולרכב אחד.'},{key:'pair',name:'זוג '+m.name,price:m.pair,p:'חוסכים '+F(m.one*2-m.pair)+' ₪. לשני כלבים, או רצועה קבועה בכל רכב.',tag:'הכי משתלם'}];
    offersWrap.innerHTML='';
    list.forEach(function(o){ var b=document.createElement('button'); b.className='offer'; b.type='button'; b.setAttribute('role','radio'); b.dataset.key=o.key;
      b.innerHTML=(o.tag?'<span class="tag">'+o.tag+'</span>':'')+'<h3>'+o.name+'</h3><div class="price">'+F(o.price)+'<small> ₪</small></div><p>'+o.p+'</p>';
      b.addEventListener('click',function(){ setSel(o); }); offersWrap.appendChild(b); if(o.key===sel) setTimeout(function(){setSel(o)},0); });
    var o=list.filter(function(x){return x.key===sel})[0]; setSel(o);
  }
  document.querySelectorAll('.model').forEach(function(x){ x.addEventListener('click',function(){ if(model!==x.dataset.m){ model=x.dataset.m; cur=0; cur2=0; build(); } }); });
  var h=''; for(var k=0;k<4;k++) C.band.forEach(function(w){ h+='<span>'+w+'</span><span class="dot">'+C.bandSep+'</span>'; });
  document.getElementById('track').innerHTML=h;
  build();
  buyBtn.addEventListener('click',function(){
    var c=colors[cur]; if(!c) return; var pair=sel==='pair';
    var it={id:pair?c[4]:c[3],quantity:1};
    if(pair&&cur2!==cur) it.properties={'צבע רצועה 2':colors[cur2][0]};
    var items=[it]; if(withBowl&&window.KLIKO.bowl) items.push({id:window.KLIKO.bowl.id,quantity:1});
    var msg=document.getElementById('previewMsg'); buyBtn.disabled=true; buyBtn.setAttribute('aria-busy','true'); var old=buyBtn.textContent; buyBtn.textContent='מוסיף לסל…';
    fetch(window.KLIKO.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'שגיאה'); }); return r.json(); })
      .then(function(){ location.href=window.KLIKO.root+'cart'; })
      .catch(function(e){ buyBtn.disabled=false; buyBtn.removeAttribute('aria-busy'); buyBtn.textContent=old; msg.textContent='לא הצלחנו להוסיף לסל: '+e.message+'. נסו שוב.'; msg.hidden=false; });
  });

  // hero product image from the gallery data
  var hi=document.getElementById('heroImg'); if(hi&&!hi.getAttribute('src')){ var f0=MODELS[Object.keys(MODELS)[0]]; if(f0&&f0.colors[0]&&f0.colors[0][2]) hi.src=f0.colors[0][2]; }
  document.querySelectorAll('.reel video').forEach(function(v){ v.addEventListener('play',function(){ document.querySelectorAll('.reel video').forEach(function(o){ if(o!==v) o.pause(); }); }); });
  var played=false;
  function load3D(){ if(played) return; played=true; var sc=document.createElement('script'); sc.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js'; sc.onload=init3D; sc.onerror=init3D; document.head.appendChild(sc); }
  var playSec=document.getElementById('play');
  if('IntersectionObserver' in window && playSec){ var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ io.disconnect(); load3D(); } },{rootMargin:'400px'}); io.observe(playSec); } else load3D();

  function init3D(){
  var host=document.getElementById('scene'), fx=document.getElementById('fx');
  if(!host) return;
  var actBtns=document.querySelectorAll('[data-act]');
  var renderer;
  try{ if(!window.THREE) throw 0; renderer=new THREE.WebGLRenderer({antialias:true}); }
  catch(e){ host.insertAdjacentHTML('beforeend','<div class="nogl">ההדמיה בתלת-ממד צריכה דפדפן שתומך ב-WebGL.</div>'); actBtns.forEach(function(b){b.disabled=true}); return; }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
  renderer.outputEncoding=THREE.sRGBEncoding;
  renderer.toneMapping=THREE.ACESFilmicToneMapping; renderer.toneMappingExposure=1.08;
  renderer.shadowMap.enabled=true; renderer.shadowMap.type=THREE.PCFSoftShadowMap;
  host.insertBefore(renderer.domElement,host.firstChild);

  var V3=function(x,y,z){ return new THREE.Vector3(x,y,z); };
  function col(c){ return new THREE.Color(c).convertSRGBToLinear(); }
  function mat(c,rough,metal,extra){ var m=new THREE.MeshStandardMaterial({color:col(c),roughness:rough===undefined?0.9:rough,metalness:metal||0}); if(extra) for(var k in extra) m[k]=extra[k]; return m; }
  function mesh(g,m,x,y,z,cast){ var o=new THREE.Mesh(g,m); o.position.set(x||0,y||0,z||0); o.castShadow=cast!==false; o.receiveShadow=true; return o; }
  function B(w,h,d){ return new THREE.BoxGeometry(w,h,d); }
  function rnd(seed){ var s=seed; return function(){ s=(s*16807)%2147483647; return (s-1)/2147483646; }; }
  var R=rnd(42);

  var scene=new THREE.Scene();
  scene.background=col(0x9fd3ff);
  scene.fog=new THREE.Fog(col(0xd4ecff),24,90);
  var camera=new THREE.PerspectiveCamera(40,1,0.05,200);
  var camTarget=V3(-1.1,1.55,-0.2), camBase=V3(2.7,2.55,4.5);

  scene.add(new THREE.HemisphereLight(col(0xeaf4ff),col(0x6b6f78),0.6));
  var sun=new THREE.DirectionalLight(col(0xfff0d8),1.7); sun.position.set(-12,9,3); sun.castShadow=true;
  sun.shadow.mapSize.set(1024,1024); var sc=sun.shadow.camera; sc.left=-4; sc.right=4; sc.top=4; sc.bottom=-2; sc.near=2; sc.far=30; sun.shadow.bias=-0.0006; sun.shadow.normalBias=0.02;
  scene.add(sun); scene.add(sun.target); sun.target.position.set(0,1,0);
  var fill=new THREE.DirectionalLight(col(0xffffff),0.35); fill.position.set(5,4,7); scene.add(fill);

  var world=new THREE.Group(); scene.add(world);
  var ground=mesh(new THREE.PlaneGeometry(260,260),mat(0x7fbf62,1),0,-0.7,0,false); ground.rotation.x=-Math.PI/2; world.add(ground);
  var verge=mesh(new THREE.PlaneGeometry(3,260),mat(0x9a9a92,1),-4.2,-0.68,0,false); verge.rotation.x=-Math.PI/2; world.add(verge);
  var movers=[];
  function addMover(o,speed,span){ o.userData.sp=speed; o.userData.span=span; world.add(o); movers.push(o); }
  var trunkM=mat(0x7a5236,1), leafMs=[mat(0x4f9a46,1),mat(0x5fae4f,1),mat(0x3f8a42,1),mat(0x7cbf55,1)];
  for(var t1=0;t1<34;t1++){
    var tr=new THREE.Group(), s=0.8+R()*1.1;
    tr.add(mesh(new THREE.CylinderGeometry(0.12*s,0.18*s,1.8*s,8),trunkM,0,0.9*s-0.7,0));
    var lm=leafMs[t1%leafMs.length];
    for(var c1=0;c1<3;c1++){ var lf=mesh(new THREE.IcosahedronGeometry((0.9+R()*0.5)*s,1),lm,(R()-0.5)*0.8*s,(2.1+c1*0.5)*s-0.7,(R()-0.5)*0.8*s); tr.add(lf); }
    tr.position.set(-7-R()*26,0,-40+R()*80); addMover(tr,1,80);
  }
  var poleM=mat(0x8b7a66,0.9);
  for(var p1=0;p1<8;p1++){ var pole=mesh(new THREE.CylinderGeometry(0.08,0.1,5,8),poleM,-5.4,1.8,-40+p1*10); addMover(pole,1,80); }
  var hillM=mat(0x6aa95a,1);
  for(var h1=0;h1<7;h1++){ var hill=mesh(new THREE.SphereGeometry(14+R()*10,24,16),hillM,-70-R()*20,-9,-60+h1*20,false); hill.scale.y=0.55; addMover(hill,0.12,140); }
  var cloudM=mat(0xffffff,1,0,{emissive:col(0xffffff),emissiveIntensity:0.35});
  for(var cl=0;cl<12;cl++){
    var cg=new THREE.Group(), cs=1.2+R()*1.8;
    for(var q=0;q<5;q++){ var puff=mesh(new THREE.IcosahedronGeometry((0.9+R()*0.8)*cs,2),cloudM,(q-2)*1.1*cs,(R()-0.3)*0.6*cs,(R()-0.5)*1.2*cs,false); puff.scale.y=0.7; cg.add(puff); }
    cg.position.set(-26-R()*40,8+R()*9,-60+cl*10); addMover(cg,0.06+R()*0.05,120);
  }

  var cabin=new THREE.Group(); scene.add(cabin);
  var fabric=mat(0xa7abb2,0.97), fabricDk=mat(0x8e939b,0.97), trim=mat(0x34373d,0.75), head=mat(0xd8d4cc,0.95);
  cabin.add(mesh(B(9,0.1,7),mat(0x2a2c30,1),0,-0.05,0));
  cabin.add(mesh(B(4.8,0.6,2.4),fabric,0,0.3,0));
  var cush=mesh(B(4.6,0.1,2.2),fabricDk,0,0.62,0.02); cabin.add(cush);
  var back=mesh(B(4.8,2.2,0.5),fabric,0,1.45,-1.42); back.rotation.x=-0.12; cabin.add(back);
  [-1.45,1.45].forEach(function(x){ cabin.add(mesh(B(0.85,0.5,0.32),fabric,x,2.85,-1.6)); });
  cabin.add(mesh(B(0.25,1.75,3.8),trim,-2.45,0.85,0));
  cabin.add(mesh(B(0.38,0.12,1.7),mat(0x45484f,0.7),-2.27,1.25,0.4));
  cabin.add(mesh(B(0.25,0.55,3.8),trim,-2.45,3.27,0));
  cabin.add(mesh(B(0.25,1.3,0.45),trim,-2.45,2.37,1.68));
  cabin.add(mesh(B(0.25,1.3,0.6),trim,-2.45,2.37,-1.6));
  var glass=new THREE.Mesh(new THREE.PlaneGeometry(2.9,1.3),new THREE.MeshStandardMaterial({color:col(0xcfe9ff),transparent:true,opacity:0.08,roughness:0.05,metalness:0,depthWrite:false}));
  glass.position.set(-2.43,2.37,0.05); glass.rotation.y=Math.PI/2; glass.position.y+=0.62; glass.scale.y=0.05; cabin.add(glass);
  cabin.add(mesh(B(0.25,3.6,3.8),trim,2.45,1.8,0));
  cabin.add(mesh(B(5.4,0.2,4.2),head,0,3.62,0,false));
  cabin.add(mesh(B(5.2,0.25,0.35),head,0,3.42,-1.78,false));
  var sock=new THREE.Group(); sock.position.set(1.3,0.62,-0.95); cabin.add(sock);
  sock.add(mesh(B(0.22,0.42,0.17),mat(0x1e1f22,0.5),0,0.18,0));
  sock.add(mesh(B(0.12,0.05,0.18),mat(0xd2302a,0.5),0,0.41,0));
  var anchorPt=V3(1.3,1.0,-0.95);

  var DS=0.55;
  var dog=new THREE.Group(); dog.rotation.order='YXZ'; dog.scale.setScalar(DS); cabin.add(dog);
  var seatPos=V3(-0.15,0.66,0.15); dog.position.copy(seatPos);
  var FUR=0xdcaa76, FUR_LT=0xefcfa3, FUR_DK=0xc58f5b;
  var curlGeo=new THREE.IcosahedronGeometry(1,1);
  var curlMat=new THREE.MeshStandardMaterial({color:0xffffff,roughness:1,metalness:0});
  function ellArea(a,b,c){ var p=1.6; return 4*Math.PI*Math.pow((Math.pow(a*b,p)+Math.pow(a*c,p)+Math.pow(b*c,p))/3,1/p); }
  function furCluster(parent,parts){
    var total=0, plan=[];
    parts.forEach(function(p){ var n=Math.round(ellArea(p.r[0],p.r[1],p.r[2])*(p.dens||70)); plan.push(n); total+=n; });
    var im=new THREE.InstancedMesh(curlGeo,curlMat,total); im.castShadow=true; im.receiveShadow=true;
    var m4=new THREE.Matrix4(), q=new THREE.Quaternion(), sv=V3(1,1,1), pos=V3(), e=new THREE.Euler(), cc=new THREE.Color(), idx=0;
    parts.forEach(function(p,pi){
      var base=new THREE.Color(p.c), n=plan[pi], rx=new THREE.Matrix4().makeRotationX(p.rx||0);
      for(var i=0;i<n;i++){
        var u=R()*2-1, th=R()*Math.PI*2, sq=Math.sqrt(1-u*u);
        var d=V3(sq*Math.cos(th),u,sq*Math.sin(th));
        pos.set(d.x*p.r[0],d.y*p.r[1],d.z*p.r[2]).applyMatrix4(rx).add(V3(p.p[0],p.p[1],p.p[2]));
        if(p.skip && p.skip(pos)){ pos.set(p.p[0],p.p[1],p.p[2]); var tiny=0.0001; sv.set(tiny,tiny,tiny); }
        else { var k=(p.cr||0.08)*(0.7+R()*0.6); sv.set(k,k*(0.8+R()*0.3),k); }
        e.set(R()*3,R()*3,R()*3); q.setFromEuler(e);
        m4.compose(pos,q,sv); im.setMatrixAt(idx,m4);
        var f=0.86+R()*0.26; cc.copy(base).multiplyScalar(f); cc.offsetHSL((R()-0.5)*0.015,0,0); cc.convertSRGBToLinear();
        im.setColorAt(idx,cc); idx++;
      }
    });
    im.instanceMatrix.needsUpdate=true; if(im.instanceColor) im.instanceColor.needsUpdate=true;
    parent.add(im); return im;
  }
  function solid(parent,p,c,rough){ var m=mesh(new THREE.SphereGeometry(1,28,20),mat(c,rough===undefined?1:rough),p.p[0],p.p[1],p.p[2]); m.scale.set(p.r[0]*0.93,p.r[1]*0.93,p.r[2]*0.93); m.rotation.x=p.rx||0; parent.add(m); return m; }

  var bodyG=new THREE.Group(); dog.add(bodyG);
  var bodyParts=[
    {p:[0,0.55,-0.2],r:[0.74,0.56,0.7],c:FUR},
    {p:[0,1.22,0.08],r:[0.6,0.84,0.56],rx:-0.18,c:FUR},
    {p:[0,1.12,0.44],r:[0.42,0.5,0.28],c:FUR_LT,dens:90,cr:0.07},
    {p:[-0.27,0.5,0.5],r:[0.15,0.5,0.15],c:FUR,dens:110,cr:0.06},
    {p:[0.27,0.5,0.5],r:[0.15,0.5,0.15],c:FUR,dens:110,cr:0.06},
    {p:[-0.27,0.08,0.62],r:[0.18,0.1,0.24],c:FUR_LT,dens:120,cr:0.05},
    {p:[0.27,0.08,0.62],r:[0.18,0.1,0.24],c:FUR_LT,dens:120,cr:0.05},
    {p:[-0.55,0.42,0.02],r:[0.28,0.36,0.5],c:FUR},
    {p:[0.55,0.42,0.02],r:[0.28,0.36,0.5],c:FUR},
    {p:[-0.58,0.08,0.45],r:[0.17,0.1,0.24],c:FUR_LT,dens:120,cr:0.05},
    {p:[0.58,0.08,0.45],r:[0.17,0.1,0.24],c:FUR_LT,dens:120,cr:0.05}
  ];
  bodyParts.forEach(function(p){ solid(bodyG,p,p.c); });
  furCluster(bodyG,bodyParts);

  var red=mat(0xc9222c,0.6), ringM=mat(0xd9dde2,0.28,0.9);
  var hb1=mesh(new THREE.TorusGeometry(0.64,0.075,12,44),red,0,1.42,0.08); hb1.rotation.x=Math.PI/2-0.25; bodyG.add(hb1);
  var hb2=mesh(new THREE.TorusGeometry(0.6,0.075,12,44),red,0,1.05,0.06); hb2.rotation.x=Math.PI/2-0.1; bodyG.add(hb2);
  var front=mesh(B(0.2,0.52,0.08),red,0,1.2,0.66); front.rotation.x=0.18; bodyG.add(front);
  var frontRing=mesh(new THREE.TorusGeometry(0.075,0.022,10,24),ringM,0,1.48,0.66); bodyG.add(frontRing);
  var backStrap=mesh(B(0.2,0.08,0.5),red,0,1.66,-0.3); backStrap.rotation.x=-0.5; bodyG.add(backStrap);
  var ring=mesh(new THREE.TorusGeometry(0.1,0.028,10,24),ringM,0,1.74,-0.48); ring.rotation.y=Math.PI/2; bodyG.add(ring);

  var headG=new THREE.Group(); headG.position.set(0,2.15,0.3); dog.add(headG);
  var eyeL=V3(-0.21,0.08,0.47), eyeR=V3(0.21,0.08,0.47), noseP=V3(0,-0.1,0.7);
  function nearFace(p){ return p.distanceTo(eyeL)<0.15||p.distanceTo(eyeR)<0.15||p.distanceTo(noseP)<0.13||(p.z>0.5&&p.y<-0.2&&Math.abs(p.x)<0.12); }
  var headParts=[
    {p:[0,0,0],r:[0.58,0.54,0.54],c:FUR,dens:85,cr:0.075,skip:nearFace},
    {p:[0,0.4,-0.04],r:[0.46,0.3,0.42],c:FUR,dens:85,cr:0.08},
    {p:[0,-0.18,0.42],r:[0.29,0.22,0.27],c:FUR_LT,dens:140,cr:0.045,skip:nearFace}
  ];
  headParts.forEach(function(p){ solid(headG,p,p.c); });
  furCluster(headG,headParts);
  var eyeM=mat(0x140c08,0.08,0.1), noseM=mat(0x3b241a,0.3);
  var eyes=[eyeL,eyeR].map(function(p){ var e=mesh(new THREE.SphereGeometry(0.075,24,16),eyeM,p.x,p.y,p.z); headG.add(e); return e; });
  var nose=mesh(new THREE.SphereGeometry(0.09,24,16),noseM,noseP.x,noseP.y,noseP.z); nose.scale.set(1.15,0.85,0.9); headG.add(nose);
  var mouth=mesh(new THREE.SphereGeometry(0.1,20,12),mat(0x5a2a26,0.6),0,-0.3,0.56); mouth.scale.set(1,0.35,0.6); headG.add(mouth);
  var tongue=mesh(new THREE.SphereGeometry(0.08,20,12),mat(0xe9788f,0.35),0,-0.36,0.6); tongue.scale.set(1,0.4,1.3); tongue.rotation.x=0.5; headG.add(tongue);
  var ears=[];
  [-1,1].forEach(function(s){
    var eg=new THREE.Group(); eg.position.set(s*0.48,0.22,-0.04); headG.add(eg);
    var part={p:[s*0.08,-0.38,0],r:[0.17,0.46,0.21],c:FUR_DK,dens:110,cr:0.07};
    solid(eg,part,FUR_DK); furCluster(eg,[part]); ears.push({g:eg,s:s});
  });
  var tailG=new THREE.Group(); tailG.position.set(0,0.75,-0.82); dog.add(tailG);
  var tailP={p:[0,0.28,-0.08],r:[0.2,0.3,0.2],c:FUR,dens:120,cr:0.07};
  solid(tailG,tailP,FUR); furCluster(tailG,[tailP]); tailG.rotation.x=-0.5;

  var strapMat=mat(0x2a2a30,0.85), bungeeMat=mat(0xc6ef3a,0.8), metal=mat(0xd2d6db,0.3,0.85);
  var tube=new THREE.Mesh(new THREE.BufferGeometry(),strapMat); tube.castShadow=true; cabin.add(tube);
  var clip=mesh(B(0.07,0.07,0.16),metal); cabin.add(clip);
  var tongueM=mesh(B(0.11,0.15,0.035),metal); tongueM.position.copy(anchorPt).add(V3(0,-0.04,0)); cabin.add(tongueM);
  var rings=[], NR=14, rg=new THREE.TorusGeometry(0.045,0.026,8,16);
  for(var i=0;i<NR;i++){ var rr=new THREE.Mesh(rg,bungeeMat); rr.castShadow=true; cabin.add(rr); rings.push(rr); }
  setStrapColor=function(c){ strapMat.color.copy(col(c)); };
  setStrapColor(colors[cur][1]);

  var ringW=V3(), tmp=V3(), tan=V3();
  function ringPos(){ cabin.updateMatrixWorld(true); ring.getWorldPosition(ringW); return cabin.worldToLocal(ringW.clone()); }
  var restLen=ringPos().distanceTo(anchorPt), maxLen=restLen+1.15;
  function updateLeash(stretch){
    var a=ringPos(), b=anchorPt;
    var sag=0.32*(1-stretch);
    var m1=a.clone().lerp(b,0.33).add(V3(0,-sag*0.6,0)), m2=a.clone().lerp(b,0.66).add(V3(0,-sag,0));
    var curve=new THREE.CatmullRomCurve3([a,m1,m2,b.clone().add(V3(0,0.04,0))]);
    tube.geometry.dispose(); tube.geometry=new THREE.TubeGeometry(curve,40,0.03,8,false);
    clip.position.copy(a); clip.lookAt(cabin.localToWorld(m1.clone()));
    for(var i=0;i<NR;i++){
      var t=0.28+0.42*(i/(NR-1)); curve.getPointAt(t,tmp); curve.getTangentAt(t,tan);
      rings[i].position.copy(tmp); rings[i].lookAt(cabin.localToWorld(tmp.clone().add(tan)));
      var s=1-0.38*stretch; rings[i].scale.set(s,s,1+stretch*0.6);
    }
  }

  function resize(){ var w=host.clientWidth, hh=host.clientHeight; renderer.setSize(w,hh,false); camera.aspect=w/hh; camera.updateProjectionMatrix(); }
  window.addEventListener('resize',resize); resize();
  var yaw=0, targetYaw=0, dragging=false, lastX=0, moved=0;
  host.addEventListener('pointerdown',function(e){ dragging=true; lastX=e.clientX; moved=0; });
  window.addEventListener('pointermove',function(e){ if(!dragging) return; var dx=e.clientX-lastX; lastX=e.clientX; moved+=Math.abs(dx); targetYaw=Math.max(-0.45,Math.min(0.45,targetYaw-dx*0.004)); if(moved>6){ var hn=document.getElementById('hint'); if(hn) hn.style.opacity='0'; } });
  window.addEventListener('pointerup',function(){ if(dragging&&moved<6) act('pet'); dragging=false; });
  window.addEventListener('pointercancel',function(){ dragging=false; });

  var T={brake:-1,jump:-1,pet:-1}, fxShown={};
  function showFx(txt){ if(!txt||!fx) return; fx.textContent=txt; fx.classList.remove('on'); void fx.offsetWidth; fx.classList.add('on'); clearTimeout(showFx.t); showFx.t=setTimeout(function(){fx.classList.remove('on')},1000); }
  function act(n){ if(n==='hop') n='jump'; if(T.jump>=0&&n!=='pet') return; T[n]=0; fxShown={}; if(n!=='jump') showFx(C.fx[n]); }
  actBtns.forEach(function(b){ b.addEventListener('click',function(){ act(b.dataset.act); }); });

  function clamp(x,a,b){ return Math.max(a,Math.min(b,x)); }
  function smooth(x){ x=clamp(x,0,1); return x*x*(3-2*x); }
  function seg(t,a,b){ return smooth((t-a)/(b-a)); }
  function bump(t){ if(t<0.18) return t/0.18; var u=t-0.18; return Math.exp(-u*4.2)*Math.cos(u*13); }

  var visible=true, clock=new THREE.Clock(), el=0, nextAuto=6, speed=1;
  if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ visible=es[0].isIntersecting; }).observe(host); }
  var windowPt=V3(-2.0,2.05,0.25);

  function frame(){
    requestAnimationFrame(frame);
    var dt=Math.min(clock.getDelta(),0.05); if(!visible) return;
    el+=dt; var t=el;
    var lurch=0; if(T.brake>=0){ T.brake+=dt/1.6; if(T.brake>=1) T.brake=-1; else lurch=bump(T.brake); }
    if(!reduce && T.brake<0 && T.jump<0 && t>nextAuto){ act('brake'); nextAuto=t+11; }
    var targetSpeed=(T.brake>=0&&T.brake<0.4)?0.15:1; speed+=(targetSpeed-speed)*Math.min(1,dt*3);
    if(!reduce){ movers.forEach(function(o){ var half=o.userData.span/2; o.position.z-=o.userData.sp*14*speed*dt; if(o.position.z<-half) o.position.z+=o.userData.span; }); }
    var shake=reduce?0:(Math.sin(t*31)*0.003+Math.sin(t*17.3)*0.002)*speed;
    cabin.position.set(0,shake,-lurch*0.06); cabin.rotation.z=reduce?0:Math.sin(t*1.3)*0.004*speed;
    var pet=0; if(T.pet>=0){ T.pet+=dt/1.8; if(T.pet>=1) T.pet=-1; else pet=Math.sin(T.pet*Math.PI); }
    var pos=seatPos.clone(), rotY=0, rotX=0, crouch=1, stretch=0, wig=0;
    if(T.jump>=0){
      T.jump+=dt/2.6; var j=T.jump;
      if(j>=1){ T.jump=-1; }
      else {
        var turn=seg(j,0,0.12)*(1-seg(j,0.8,0.95));
        rotY=-1.25*turn;
        crouch=1-0.12*seg(j,0.06,0.16)*(1-seg(j,0.16,0.2));
        var go=seg(j,0.16,0.38)*(1-seg(j,0.62,0.86));
        pos.lerp(windowPt,go); pos.y+=Math.sin(go*Math.PI)*0.35;
        rotX=0.5*go;
        if(j>0.36&&j<0.66){ wig=Math.sin((j-0.36)*60)*0.05; }
        if(j>0.86){ pos.y+=Math.abs(Math.sin((j-0.86)*22))*0.06*(1-j); }
        if(j>0.14&&!fxShown.a){ fxShown.a=1; showFx(C.fx.jump1); }
        if(j>0.4&&!fxShown.b){ fxShown.b=1; showFx(C.fx.jump2); }
      }
    }
    pos.z+=lurch*0.4; pos.x+=wig;
    dog.position.copy(pos); dog.rotation.set(rotX+lurch*0.3,rotY,wig*0.6);
    dog.scale.set(DS,DS*crouch,DS);
    var rp=ringPos(), d=rp.distanceTo(anchorPt);
    if(d>maxLen){ var corr=rp.clone().sub(anchorPt).setLength(maxLen).add(anchorPt).sub(rp); dog.position.add(corr); rp.add(corr); d=maxLen; }
    stretch=clamp((d-restLen)/(maxLen-restLen),0,1);
    stretch=Math.max(stretch,Math.max(0,lurch)*0.8);
    if(!reduce){
      tailG.rotation.z=Math.sin(t*(pet>0||T.jump>=0?17:8))*0.5;
      headG.rotation.z=Math.sin(t*0.9)*0.08+pet*0.3;
      headG.rotation.x=-lurch*0.25+(T.jump>=0?-0.25*stretch:0);
      ears.forEach(function(e){ e.g.rotation.x=-lurch*0.5-stretch*0.4+Math.sin(t*2+e.s)*0.04; e.g.rotation.z=e.s*(0.06+Math.sin(t*1.5+e.s)*0.05+stretch*0.25); });
      tongue.position.y=-0.36+Math.sin(t*7)*0.01;
    }
    eyes.forEach(function(e){ e.scale.y=1-pet*0.85; });
    updateLeash(stretch);
    yaw+=(targetYaw-yaw)*0.1;
    var off=camBase.clone().sub(camTarget).applyAxisAngle(V3(0,1,0),yaw+(reduce?0:Math.sin(t*0.35)*0.03));
    var narrow=camera.aspect<0.95; if(narrow) off.multiplyScalar(1.15);
    camera.position.copy(camTarget).add(off); camera.lookAt(camTarget);
    renderer.render(scene,camera);
  }
  frame();
  }
})();
